import { render } from "./activate-modal.vue?vue&type=template&id=3a09db78"
import script from "./activate-modal.vue?vue&type=script&lang=js"
export * from "./activate-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__